import { partners, trustBadges } from "../lib/content";
import { CheckIcon } from "./Icons";

/**
 * Certification badges and partner names.
 *
 * Partner names are rendered as text rather than hot-linking logo files: the
 * live site points at `www.costq.ai/images/partner/*`, which is a different
 * domain and an old brand. See the README for adding real logo assets.
 */
export default function TrustBar() {
  return (
    <section className="border-y border-ink-line bg-white py-10">
      <div className="container-page">
        <ul className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {trustBadges.map((badge) => (
            <li key={badge} className="inline-flex items-center gap-2 text-sm font-medium text-ink-muted">
              <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-accent-success/15 text-accent-success">
                <CheckIcon className="h-3 w-3" />
              </span>
              {badge}
            </li>
          ))}
        </ul>

        <div className="mt-8 border-t border-ink-line pt-8">
          <p className="text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-ink-muted">
            {partners.caption}
          </p>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {partners.names.map((name) => (
              <li key={name} className="text-sm font-semibold uppercase tracking-wide text-ink-muted/70">
                {name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
